import React from 'react';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../../../components/Common/UI/Button';
import { StepProps } from '../../index';
import PdfViewer from '../../../../../../../components/Common/PdfViewer';
import { getGuidanceSettingsFromStorage } from '../../../../../../../components/Pages/Home/SettingsModal/storage-utils';

export default function Step1Content({ handleNextStep }: StepProps) {
  const { showCaptcha } = getGuidanceSettingsFromStorage();

  return (
    <>
      <div className="flex gap-4 items-center">
        <div>
          <Icons.AccountsFilled />
        </div>
        <div>
          <h2 className="text-lg font-bold">Enrollment Step 1 - eStatement Verification</h2>
          <p className="text-sm">Please let us know if you can see the eStatement below.</p>
        </div>
      </div>

      <PdfViewer dependOnPdfSettings src="/financialInstitution/statements/bill.pdf" />

      <div className="flex flex-wrap gap-4 justify-center sm:justify-between items-center ">
        <Button className="bg-[#EF9F00] hover:bg-[#EF9F00E6]">I CANNOT see it</Button>
        {/** If captcha disabled then skip step 2. */}
        <Button className="bg-[#51CF7C] hover:bg-[#51CF7CE6]" onClick={() => handleNextStep(showCaptcha === false)}>
          I CAN see it
        </Button>
      </div>
    </>
  );
}
